export default "__VITE_PUBLIC_ASSET__80980f62__"